import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { 
  Button, 
  Checkbox, 
  TableCell, 
  TableRow,
  Tooltip, 
} from '@material-ui/core';
import NumberFormat from 'react-number-format';
import { startAlerta } from "../../../actions/ui/alertas";
import { Error } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    paper: {
      width: "100%",
      marginBottom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    rootTableRow: {
      '& > *': {
        borderBottom: 'unset',
      },
    },
  }));

export const TableRowGeneracion = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { row, isItemSelected, labelId, handleClick, handleEditPropuestaAfiliado } = props;
    
    const [periodo, setPeriodo] = useState(row.periodo);
    const [importe, setImporte] = useState(row.importe);
    const [importeReImputacion, setImporteReImputacion] = useState(row.reImputacion);

    const verifyMaxValue = (inputObj) => {
      const { floatValue } = inputObj;

      if (!floatValue || floatValue === -0) return true;
      if (floatValue <= importe && floatValue <= (row.deudaAnt * -1) && floatValue > 0) return true;
      return false;
    }

    const verifyValue = (inputObj) => {
      const { value } = inputObj;
      
      if (value.length < 6) return true;
      
      const dateNow = new Date();
      const yearNow = dateNow.getFullYear();
      const monthNow = dateNow.getMonth() + 1;
      const year = parseInt(value.substring(0, 4));
      const month = parseInt(value.substring(4, 6));

      console.log(year + " " + month);

      if(year > yearNow+1) {
        dispatch( startAlerta(`El periodo puede ser como máximo perteneciente al año próximo`, "error") );
        return false;
      } else if (year <= yearNow+1 && year > (yearNow-11) && month > 0 && month <= 12){
        if(year === yearNow && month > monthNow){
          dispatch( startAlerta(`El periodo debe ser menor o igual al actual`, "error") );
          return false;
        }else{
          return true;
        }
      } 
      
      dispatch( startAlerta(`El año debe ser mayor a ${yearNow-11} y el mes debe ser menor a 13`, "error") );
      return false;
    }

    const cellColor = row.deudaAnt.toFixed(2) < 0 ? '#ff0000' : '#000000';

    return (
      <>
        <TableRow
          hover
          role="checkbox"
          aria-checked={isItemSelected}
          tabIndex={-1}
          key={row.idAfiliado}
          selected={isItemSelected}
          className={classes.rootTableRow}
        >
          <TableCell padding="checkbox">
            <Checkbox
              checked={isItemSelected}
              inputProps={{ "aria-labelledby": labelId }}
              onClick={(event) => handleClick(event, row)}
            />
          </TableCell>
          <TableCell padding="right">
            {row.agregado ? 
              <Tooltip title="Agregado manualmente">
                <span>
                  <Error color="warning" />
                </span>
              </Tooltip>
              :
              ""
          }
          </TableCell>
          <TableCell padding="none">{row.apellidoNombre}</TableCell>
          <TableCell align="right" >{row.cuil}</TableCell>
          <TableCell >{row.descripcionAfiliacion}</TableCell>
          <TableCell >{row.empresa}</TableCell>
          <TableCell align="right" >{row.cuitEmpresa}</TableCell>
          {row.agregado
            ?
              <TableCell align="center" >
                <NumberFormat
                  style={{maxWidth: 70}}
                  onChange={(e) => setPeriodo(e.target.value)}
                  value={periodo}
                  isAllowed={verifyValue}
                  allowNegative={false}
                  disabled={!row.agregado}
                  isNumericString
                  format="######"
                />
              </TableCell>
            :
              <TableCell align="center" >{row.periodo}</TableCell>
          }
          <TableCell align="center" >
            <NumberFormat
              style={{maxWidth: 100}}
              onChange={(e) => setImporte(e.target.value)}
              value={importe}
              // thousandSeparator
              isNumericString
              // prefix="$"
            />
          </TableCell>
          <TableCell align="center" >
            <NumberFormat
              style={{maxWidth: 100}}
              onChange={(e) => setImporteReImputacion(e.target.value)}
              value={importeReImputacion}
              isAllowed={verifyMaxValue}
              disabled={row.deudaAnt >= 0 || !importe}
              // thousandSeparator
              isNumericString
              // prefix="$"
            />
          </TableCell>
          <TableCell align="center" style={{color: cellColor}} >{row.deudaAnt.toFixed(2)}</TableCell>
          {/* <TableCell align="center" >{(row.importe + row.deudaAnt).toFixed(2)}</TableCell> */}
          <Button 
              variant="contained" 
              color="primary" 
              style={{margin: 15}}
              disabled={parseFloat(importe) === 0 || parseFloat(importe) < 0 || !importe ||!periodo || isNaN(parseFloat(importe)) || periodo?.toString().trim().length < 6
                || (parseFloat(importe) === row.importe && (parseFloat(importeReImputacion) === row.reImputacion || !importeReImputacion)
                  && (row.periodo === parseInt(periodo)))
              }
              onClick={() => handleEditPropuestaAfiliado(row, importe, importeReImputacion, periodo)}
          >
              GRABAR
          </Button>
        </TableRow>
      </>
    );
  }